// ada fixes for rich text content & announcement bar text, adds tabindex to paragraphs to make them focusable
(function () {

  function addTabIndexToRichText() {

    document.querySelectorAll('.rich-text__content .rich-text__text.is-hidden-mobile-only p, .announcement-bar__text .is-hidden-mobile-only p, .rich-text__heading.is-hidden-mobile-only, .mega-menu__content p, .featured-collection__title,.footer__block p, .heading-section__subheading p, .page__title.title, .cart-page__title.title')
      .forEach(p => {
        // Skip elements inside Ajax Cart
        if (p.closest('[data-ajax-cart-content]')) return;
        p.setAttribute('tabindex', '0');
      });

  }

  // run on page load
  document.addEventListener('DOMContentLoaded', addTabIndexToRichText);

})();

// ada fixes for product thumbnail overlays, adds aria-hidden and tabindex to empty links to make them non-focusable
(function () {

  function fixThumbnailAccessibility() {

    // Fix empty overlay links
    document.querySelectorAll('.thumbnail-overlay__container > a:first-child').forEach(link => {
      if (!link.textContent.trim() && !link.querySelector('img')) {
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('tabindex', '-1');
      }
    });

    // Fix hidden product links
    document.querySelectorAll('.thumbnail-overlay__container .hidden-product-link').forEach(link => {
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('tabindex', '-1');
    });

  }

  // Run on initial load
  document.addEventListener("DOMContentLoaded", function () {
    fixThumbnailAccessibility();
  });

  // Observe DOM changes (Shopify loads products dynamically)
  const thumbnailObserver = new MutationObserver(() => {
    fixThumbnailAccessibility();
  });

  thumbnailObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


// ADA fix: Announce "Viewing details of [product]" when user presses Enter on a
// product image or title link. Uses aria-live so the SR speaks it at activation time.
(function () {

  function getAnnouncer() {
    var el = document.getElementById('product-link-announcer');
    if (!el) {
      el = document.createElement('div');
      el.id = 'product-link-announcer';
      el.setAttribute('aria-live', 'assertive');
      el.setAttribute('aria-atomic', 'true');
      el.style.position = 'absolute';
      el.style.width = '1px';
      el.style.height = '1px';
      el.style.margin = '-1px';
      el.style.padding = '0';
      el.style.overflow = 'hidden';
      el.style.clip = 'rect(0,0,0,0)';
      el.style.border = '0';
      document.body.appendChild(el);
    }
    return el;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;

    var productName = '';
    var href = '';

    // Case 1: Enter on the product image link.
    // Do NOT use link.textContent — lazy-load renders output image URLs as text nodes.
    // Instead walk the DOM to find the product title.
    var imageLink = e.target.closest('.image__container.product__imageContainer a, .boost-sd__product-image-wrapper a');
    if (imageLink) {
      href = imageLink.getAttribute('href');
      var card = imageLink.closest('.product-wrap, .product__thumbnail, .thumbnail');
      if (card) {
        var titleEl = card.querySelector('.hidden-product-link, a.product-thumbnail__title, .product-thumbnail__title');
        if (titleEl) productName = titleEl.textContent.trim();
      }
    }

    // Case 2: Enter on the product title link.
    var titleLink = e.target.closest('a.product-thumbnail__title, a.boost-sd__product-link');
    if (titleLink) {
      href = titleLink.getAttribute('href');
      var ariaLabel = titleLink.getAttribute('aria-label') || '';
      productName = ariaLabel.replace(/^view details of\s*/i, '').trim()
        || titleLink.textContent.trim();
    }

    if (!productName || !href) return;

    e.preventDefault();

    var announcer = getAnnouncer();
    announcer.textContent = '';

    setTimeout(function () {
      announcer.textContent = 'View details of ' + productName;
    }, 50);

    setTimeout(function () {
      window.location.href = href;
    }, 400);
  });

})();

// Hide secondary images in product thumbnails from screen readers and keyboard navigation to prevent confusion, as they are decorative and not meant to be focused on or read by assistive technologies.
(function () {

  function hideSecondaryImages() {

    const secondaryImages = document.querySelectorAll(
      '.product__imageContainer img.secondary, img.secondary'
    );

    secondaryImages.forEach(img => {

      // Hide from screen readers
      img.setAttribute('aria-hidden', 'true');

      // Decorative image → empty alt
      img.setAttribute('alt', '');

      // Prevent accidental focus (rare but safe)
      img.setAttribute('tabindex', '-1');

    });

  }

  // Run on load
  window.addEventListener('load', hideSecondaryImages);

  // Run after AJAX / Boost / infinite scroll / filters
  const observer = new MutationObserver(hideSecondaryImages);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

// Fixes for payment icons in the footer, adds tabindex and aria-label for better accessibility
document.addEventListener('DOMContentLoaded', function () {
  const paymentIcons = document.querySelectorAll('.payment-icon');

  paymentIcons.forEach(function (svg) {
    // 1. Make it focusable for keyboard users
    svg.setAttribute('tabindex', '0');

    // 2. Set the aria-label based on the internal <title> text
    const title = svg.querySelector('title');
    if (title && title.textContent) {
      svg.setAttribute('aria-label', title.textContent);
    }

    // 3. Optional: Add a custom focus style via JS if you can't edit CSS
    svg.style.outlineOffset = '2px';
  });
});

// Fixes for Boost header title, adds tabindex to make it focusable for keyboard users
const fixBoostHeaderA11y = () => {
  // 1. Add tabindex to existing elements
  const boostElements = document.querySelectorAll('.boost-sd__header-title, .boost-sd__breadcrumb-link, .boost-sd__view-as-text, .boost-sd__product-label-text span, .boost-sd__header-description');
  boostElements.forEach(el => el.setAttribute('tabindex', '0'));

  // 2. Wrap loose text (the number "1") in a focusable span
  const breadcrumbContainer = document.querySelector('.boost-sd__breadcrumb-container');
  if (breadcrumbContainer) {
    // Iterate through child nodes to find the loose "1"
    breadcrumbContainer.childNodes.forEach(node => {
      // Check if it's a text node containing exactly "1" (ignoring whitespace)
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '1') {
        const span = document.createElement('span');
        span.className = 'boost-sd__breadcrumb-number';
        span.setAttribute('tabindex', '0');
        span.style.transition = 'all';
        span.textContent = '1';

        // Replace the loose text node with the new focusable span
        node.parentNode.replaceChild(span, node);
      }
    });
  }
};

// Keep your existing MutationObserver and initial call below
const boostObserver = new MutationObserver(() => fixBoostHeaderA11y());
boostObserver.observe(document.body, { childList: true, subtree: true });
fixBoostHeaderA11y();


(function () {
  function addTabIndexToCollectionListButtons() {
    // This finds all buttons inside the caption wrappers (the 3 you mentioned)
    const buttons = document.querySelectorAll('.collection-list__caption-wrapper button');

    buttons.forEach(btn => {
      btn.setAttribute('tabindex', '-1');
    });
  }

  // Run immediately and also on DOMContentLoaded
  addTabIndexToCollectionListButtons();
  document.addEventListener('DOMContentLoaded', addTabIndexToCollectionListButtons);

})();

// Fixes for Boost filter swatches, adds aria-label and role for better accessibility
const fixBoostSwatchesA11y = () => {
  const swatchButtons = document.querySelectorAll('.boost-sd__filter-option-swatch-item button[title]');

  swatchButtons.forEach(button => {
    // Only update if aria-label is missing or generic
    if (!button.hasAttribute('aria-label') || button.getAttribute('aria-label') === 'button') {
      const fullTitle = button.getAttribute('title'); // e.g., "Find product with PRINT is Lunar Rock"

      // Extract just the color/print name (everything after 'is ')
      const colorName = fullTitle.split(' is ').pop();

      if (colorName) {
        if (fullTitle.toUpperCase().includes('PRINT')) {
          button.setAttribute('aria-label', `Print: ${colorName}`);
        } else {
          button.setAttribute('aria-label', `Color: ${colorName}`);
        }
        // Changed to 'button' to suppress native "checked/not checked" announcements
        button.setAttribute('role', 'button');
      }
    }
  });
};

// Observe Boost Filter dynamic changes
const swatchObserver = new MutationObserver((mutations) => {
  mutations.forEach(() => fixBoostSwatchesA11y());
});

swatchObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Initial run
fixBoostSwatchesA11y();


// Fixes for Boost/Loox product ratings, adds aria-label and role for better accessibility
const fixProductRatingsA11y = () => {
  const ratings = document.querySelectorAll('.loox-rating[data-rating]');

  ratings.forEach(rating => {
    // 1. Get the data from attributes
    const score = rating.getAttribute('data-rating') || "0";
    const votes = rating.getAttribute('data-raters') || "0";
    const label = `${score} out of 5 stars based on ${votes} reviews`;

    // 2. Set a clean aria-label and change role to 'img' (standard for icons)
    rating.setAttribute('aria-label', label);
    rating.setAttribute('role', 'img');
    rating.setAttribute('tabindex', '0');

    // 3. Hide all internal content from screen readers to prevent "double reading"
    const content = rating.querySelector('.loox-rating-content');
    if (content) {
      content.setAttribute('aria-hidden', 'true');
    }
  });
};

// Observe for Boost/Loox dynamic loading
const ratingObserver = new MutationObserver(() => fixProductRatingsA11y());
ratingObserver.observe(document.body, { childList: true, subtree: true });

// Run once
fixProductRatingsA11y();


// Fixes for Boost "Back to Top" button, ensures it focuses the search input after scrolling to top for better accessibility
(function () {
  const handleBackToTopFocus = (e) => {
    const searchInput = document.querySelector('.boost-sd__in-collection-search-input');

    if (searchInput) {
      // We use a timeout to wait for the scroll animation to finish 
      // or at least start, so the focus doesn't feel jarring.
      setTimeout(() => {
        searchInput.focus();

        // Optional: ensure the page actually scrolled 
        // if the original button script failed
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  // Use delegation because the "Back to Top" button is often dynamic
  document.addEventListener('click', function (e) {
    if (e.target.closest('.boost-sd__scroll-to-top')) {
      handleBackToTopFocus(e);
    }
  });

  // Also handle the "Enter" key for keyboard accessibility
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest('.boost-sd__scroll-to-top')) {
      handleBackToTopFocus(e);
    }
  });

})();


// Fixes for Boost header navigation flow, ensures logical tab order between "Back to Top", Search Button, and Search Input for better accessibility
(function () {
  const handleNavigation = (e) => {
    const isShiftTab = e.shiftKey && e.key === 'Tab';
    const isTab = !e.shiftKey && e.key === 'Tab';
    const active = document.activeElement;

    // 1. Fix the "Back to Top" to Search Input flow
    const backToTop = active.closest('.boost-sd__scroll-to-top');
    if (backToTop && (isTab || e.key === 'Enter')) {
      const searchInput = document.querySelector('.boost-sd__in-collection-search-input');
      if (searchInput) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => searchInput.focus(), 100);
        return;
      }
    }

    // 2. Fix the Search Button to Search Input (Backward) flow
    const searchBtn = active.closest('.boost-sd__in-collection-search-submit-btn');
    if (searchBtn && isShiftTab) {
      const container = searchBtn.closest('.boost-sd__in-collection-search');
      const input = container ? container.querySelector('.boost-sd__in-collection-search-input') : null;
      if (input) {
        e.preventDefault();
        e.stopImmediatePropagation();
        input.focus();
      }
    }
  };

  // Attach to window in capture phase to beat internal app scripts
  window.addEventListener('keydown', handleNavigation, true);

  // Prevent any '?' from being added to the URL by clicking search buttons
  document.addEventListener('submit', (e) => {
    if (e.target.closest('.boost-sd__in-collection-search')) {
      e.preventDefault();
    }
  }, true);
})();



(function () {
  // Target all accordion content containers and the contact form text which may contain raw text nodes that need to be wrapped for better accessibility
  const accordionPanels = document.querySelectorAll('.faq-accordion .content, dd .content, .contact-form__text');

  accordionPanels.forEach(panel => {
    const paragraphs = panel.querySelectorAll('p');

    paragraphs.forEach(p => {
      // Convert childNodes to array to iterate safely while modifying
      const nodes = Array.from(p.childNodes);

      nodes.forEach(node => {
        // Only wrap raw text nodes that aren't empty
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0) {
          const span = document.createElement('span');
          span.setAttribute('tabindex', '0');
          span.classList.add('focusable-text'); // Add a class for easy styling
          span.textContent = node.textContent;

          // Replace the raw text with our focusable span
          p.replaceChild(span, node);
        }
      });
    });
  });
})();



// Function to fix ARIA issues with variant option names in the Gift card by restructuring the HTML to separate the option name and value into distinct elements with appropriate ARIA attributes, improving accessibility for screen readers and keyboard users when selecting product variants.
(function () {

  function fixVariantOptionAccessibility() {

    document.querySelectorAll('.options-selection__option-name').forEach(function (container) {

      // Remove tabindex from parent
      container.removeAttribute('tabindex');

      // Prevent duplicate processing
      if (container.querySelector('.ada-option-label')) return;

      const textNode = container.childNodes[0];

      if (textNode && textNode.nodeType === 3 && textNode.textContent.trim() !== '') {

        const labelSpan = document.createElement('span');
        labelSpan.className = 'ada-option-label';
        labelSpan.setAttribute('tabindex', '0');
        labelSpan.textContent = textNode.textContent.trim();

        // Insert label span
        container.insertBefore(labelSpan, textNode);

        // Add space after first span
        const space = document.createTextNode(' ');
        container.insertBefore(space, textNode);

        // Remove original text node
        container.removeChild(textNode);
      }

      // Add tabindex to value span
      const valueSpan = container.querySelector('span:not(.ada-option-label)');
      if (valueSpan) {
        valueSpan.setAttribute('tabindex', '0');
      }

    });

  }

  document.addEventListener("DOMContentLoaded", function () {
    fixVariantOptionAccessibility();
  });

  const variantObserver = new MutationObserver(function () {
    fixVariantOptionAccessibility();
  });

  variantObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

// Add tabindex to product description paragraphs for better accessibility, allowing keyboard users to navigate through the product description text and have it announced by screen readers, improving the overall user experience for those relying on assistive technologies.
$(document).ready(function () {
  var $container = $('.pdacd_description');

  // 1. Add tabindex to the list items and paragraphs
  $container.find('li, p').attr('tabindex', '0');
  $container.find('ul li').attr('tabindex', '0');
  $container.find('p span').attr('tabindex', '0');
  $container.find('p span').attr('tabindex', '0');

  // 2. Remove tabindex from the parent container to prevent "double tabbing"
  // This ensures the focus goes directly to the first line of text.
  if ($container.find('li, p').length > 0) {
    $container.removeAttr('tabindex');
  }

  // 3. Optional: Fix for empty <p> tags (like the one at the top of your HTML)
  $container.find('p').each(function () {
    if ($(this).text().trim() === "") {
      $(this).removeAttr('tabindex'); // Don't focus empty lines
    }

    const $p = $(this);

    // Skip if already processed
    if ($p.find('.bullet-item').length) return;

    // Get HTML and split by <br>
    const parts = $p.html().split(/<br\s*\/?>/i);

    $p.empty(); // clear original content

    parts.forEach(function (part) {

      const text = $('<div>').html(part).text().trim();

      if (text !== '') {

        const $span = $('<span class="bullet-item"></span>')
          .attr('tabindex', '0')
          .html(part.trim());

        $p.append($span);
      }

    });
  });


  // Remove tabindex from parent container
  $container.removeAttr('tabindex');

});


// ADA fix for the cart taxes and shipping message (Only for the main cart page, not Ajax cart)
(function () {
  const cartMessage = document.querySelector('.cart__form .cart__taxes-shipping-message');
  if (!cartMessage) return;

  // Convert child nodes to an array to iterate safely while modifying the DOM
  const nodes = Array.from(cartMessage.childNodes);

  nodes.forEach(node => {
    // Only target raw text nodes (nodeType 3) that aren't empty
    if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0) {
      const span = document.createElement('span');
      span.setAttribute('tabindex', '0');
      span.style.outline = 'none'; // Optional: keeps layout clean
      span.textContent = node.textContent;

      // Replace the raw text with the focusable span
      cartMessage.replaceChild(span, node);
    }
  });
})();


// // ADA fix: Move focus to close icon when size chart modal last element is reached, ensures that keyboard users can easily close the modal after navigating through the size chart content, improving the overall accessibility and user experience of the size chart feature.
document.addEventListener('DOMContentLoaded', function () {

  const lastCell = document.getElementById('size-p3x-inseam');
  const closeBtn = document.querySelector('.popup-close.close.pp');

  if (lastCell && closeBtn) {

    lastCell.addEventListener('keydown', function (e) {

      // Only handle TAB (forward)
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault(); // stop normal tab flow
        closeBtn.focus();   // move focus to close button
      }

    });

  }

});



document.addEventListener('DOMContentLoaded', function () {

  function fixPrices() {

    const wrappers = document.querySelectorAll('.boost-sd__product-price-content');

    wrappers.forEach((wrapper) => {

      // ❌ Remove aria-hidden from wrapper
      if (wrapper.hasAttribute('aria-hidden')) {
        wrapper.removeAttribute('aria-hidden');
      }

      // 🎯 Target actual price text
      const price = wrapper.querySelector('.boost-sd__format-currency');

      if (price) {
        price.setAttribute('tabindex', '0');
      }

    });

  }

  // Initial run
  fixPrices();

  // 🔁 Handle Boost dynamic updates
  const observer = new MutationObserver(() => {
    fixPrices();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

// ADA fix: Wrap text in rich text sections that contain <br> with focusable spans, ensuring that screen readers can properly announce the content and keyboard users can navigate through it, improving accessibility for product descriptions and announcement bars that use rich text formatting.
$(document).ready(function () {

  function wrapRichTextWithBr() {

    $('.rich-text__text p').each(function () {

      const $p = $(this);

      // Only run if <br> exists
      if ($p.find('br').length === 0) return;

      // Skip if already processed
      if ($p.find('.focus-text-wrapper').length) return;

      let wrapped = false;

      $p.contents().each(function () {

        // Target ONLY text nodes (ignore <a>, <strong>, etc.)
        if (this.nodeType === Node.TEXT_NODE && this.textContent.trim() !== '' && !wrapped) {

          const span = $('<span class="focus-text-wrapper"></span>')
            .attr('tabindex', '0')
            .text(this.textContent.trim());

          $(this).replaceWith(span);
          wrapped = true; // only wrap first text block
        }

      });

      // Remove tabindex from <p> to avoid double tab
      $p.removeAttr('tabindex');

    });

  }

  // Run on load
  wrapRichTextWithBr();

  // Handle dynamic content (Shopify sections)
  const observer = new MutationObserver(wrapRichTextWithBr);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


});

// ADA fix: Announce "{filterName} has been selected / deselected" when user toggles a filter checkbox in Boost Filter.
(function () {
  /**
   * Creates a fresh, temporary assertive live region and announces the text.
   * This "fresh announcer" pattern is more reliable for consecutive updates.
   * @param {string} text The announcement text.
   */
  function announce(text) {
    const announcer = document.createElement('div');
    announcer.setAttribute('aria-live', 'assertive');
    announcer.setAttribute('aria-atomic', 'true');
    announcer.style.position = 'absolute';
    announcer.style.width = '1px';
    announcer.style.height = '1px';
    announcer.style.margin = '-1px';
    announcer.style.padding = '0';
    announcer.style.overflow = 'hidden';
    announcer.style.clip = 'rect(0,0,0,0)';
    announcer.style.border = '0';
    document.body.appendChild(announcer);

    // Short delay to ensure the SR registers the live region before text is added
    setTimeout(function () {
      announcer.textContent = text;
      // Cleanup: remove the announcer after it's likely been read
      setTimeout(function () {
        if (announcer.parentNode) {
          announcer.parentNode.removeChild(announcer);
        }
      }, 1500);
    }, 50);
  }

  /**
   * Extracts the filter name and triggers the announcement.
   * @param {HTMLElement} button The checkbox button element.
   */
  function handleFilterToggle(button) {
    if (!button) return;

    let filterName = '';
    const labelEl = button.querySelector('.boost-sd__filter-option-item-label');

    if (labelEl) {
      filterName = labelEl.textContent.trim();
    } else {
      const ariaLabel = button.getAttribute('aria-label') || button.getAttribute('title') || '';
      if (ariaLabel) {
        // Handle various Boost patterns: "Print: ColorName", "Find product with STYLE is StyleName", etc.
        filterName = ariaLabel
          .replace(/^(Find product with .* is |Print: |Color: |Find product with )/i, '')
          .split('.')[0]
          .trim();
      }
    }

    if (!filterName) return;

    // Use predicted state logic because Boost Filter often re-renders or stops propagation.
    const wasChecked = button.getAttribute('aria-checked') === 'true';
    const newStatus = wasChecked ? 'deselected' : 'selected';
    const announcement = filterName + ' has been ' + newStatus;

    // Delay slightly to avoid clashing with native SR behavior
    setTimeout(function () {
      announce(announcement);
    }, 250);
  }

  // Broad selector to catch Boost filter buttons even after their role is changed from 'checkbox' to 'button'.
  const filterSelector = 'button[role="checkbox"], button[role="button"][class*="boost-sd"], .boost-sd__filter-option-item-button, .boost-sd__filter-option-swatch-item button';

  // Use the CAPTURE phase (true) to ensure we see the event even if Boost Filter calls stopPropagation().
  document.addEventListener('click', function (e) {
    // 1. Handle regular filter toggle (Checkboxes/Buttons)
    const button = e.target.closest(filterSelector);
    if (button) {
      handleFilterToggle(button);
      return;
    }

    // 2. Handle "Clear All" filters
    const clearAllBtn = e.target.closest('#boost-sd__button--clear-all-filters');
    if (clearAllBtn) {
      announce('Filters all cleared. Results have been refreshed.');
      return;
    }

    // 3. Handle individual "Clear Filter" buttons (Refine By section)
    const clearItemBtn = e.target.closest('.boost-sd__refine-by-vertical-refine-by-item');
    if (clearItemBtn) {
      const valueEl = clearItemBtn.querySelector('.boost-sd__refine-by-vertical-refine-by-value');
      let filterName = '';
      if (valueEl) {
        filterName = valueEl.textContent.trim();
      } else {
        const ariaLabel = clearItemBtn.getAttribute('aria-label') || '';
        // Extract filter name from aria-label (e.g. "Clear STYLE: Chemise" -> "Chemise")
        filterName = ariaLabel.replace(/^Clear\s+/i, '').split(':')[1] || ariaLabel.replace(/^Clear\s+/i, '');
      }
      announce('Filter ' + filterName.trim() + ' cleared. Results have been refreshed.');
      return;
    }

    // 4. Handle "Clear" buttons on individual filter groups (e.g. "Clear: STYLE")
    const clearGroupBtn = e.target.closest('.boost-sd__filter-option-label-btn');
    if (clearGroupBtn) {
      announce('Clear filter, results have been refreshed.');
    }
  }, true);

  /**
   * Changes the role of Boost filters from 'checkbox' to 'button' to suppress
   * the native "checked/unchecked" announcements, allowing our custom messages to take over.
   */
  function suppressNativeCheckboxSpeech() {
    const filters = document.querySelectorAll('button[role="checkbox"]');
    filters.forEach(function (btn) {
      if (btn.closest('#boost-sd-filter-tree-column, .boost-sd__filter-tree-vertical, .boost-sd__filter-tree-vertical-content')) {
        btn.setAttribute('role', 'button');
      }
    });
  }

  // Run on initial load and observe for dynamic filter re-renders
  suppressNativeCheckboxSpeech();
  const observer = new MutationObserver(suppressNativeCheckboxSpeech);
  observer.observe(document.body, { childList: true, subtree: true });

})();

// Universal Cart Accessibility System (Sequential Announcements & Focus Management)
(function () {
  // 0. Global Interceptor for all cart additions (Catches theme AND third-party apps)
  const originalFetch = window.fetch;
  window.fetch = function () {
    const arg = arguments[0];
    const isCartAdd = typeof arg === 'string' && arg.includes('/cart/add');

    return originalFetch.apply(this, arguments).then(async (response) => {
      if (isCartAdd && response.ok) {
        try {
          const clone = response.clone();
          const data = await clone.json();

          // Capture product info from any common Shopify key
          let detail = '';
          if (data.items && data.items[0]) {
            detail = data.items[0].product_title || data.items[0].title || data.items[0].name;
          } else {
            detail = data.product_title || data.title || data.name || data.handle;
          }

          if (!detail || detail === '') detail = 'Product';

          // Try to get price
          try {
            const priceVal = (data.items && data.items[0]) ? data.items[0].price : data.price;
            if (priceVal && window.theme && window.theme.Currency) {
              const formatted = window.theme.Currency.formatMoney(priceVal, window.theme.moneyFormat);
              if (formatted) detail += ' - ' + formatted;
            }
          } catch (e) { }

          console.info('ADA::Cart - Captured addition via Fetch:', detail);
          window._pendingCartDetails = detail;
        } catch (e) {
          console.warn('ADA::Cart - Failed to parse cart addition', e);
        }
      }
      return response;
    });
  };

  // 0b. XHR Interceptor (for apps using older AJAX)
  const originalXHR = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function () {
    this.addEventListener('load', () => {
      if (this.responseURL.includes('/cart/add') && this.status === 200) {
        try {
          const data = JSON.parse(this.responseText);
          let detail = '';
          if (data.items && data.items[0]) {
            detail = data.items[0].product_title || data.items[0].title || data.items[0].name;
          } else {
            detail = data.product_title || data.title || data.name || data.handle;
          }

          if (!detail || detail === '') detail = 'Product';

          // Try to get price
          try {
            const priceVal = (data.items && data.items[0]) ? data.items[0].price : data.price;
            if (priceVal && window.theme && window.theme.Currency) {
              const formatted = window.theme.Currency.formatMoney(priceVal, window.theme.moneyFormat);
              if (formatted) detail += ' - ' + formatted;
            }
          } catch (e) { }

          console.info('ADA::Cart - Captured addition via XHR:', detail);
          window._pendingCartDetails = detail;
        } catch (e) { }
      }
    });
    return originalXHR.apply(this, arguments);
  };

  // 1. Highly assertive announcement method
  const announceToSR = (msg) => {
    if (!msg) return;
    const announcer = document.createElement('div');
    announcer.setAttribute('role', 'status');
    announcer.setAttribute('aria-live', 'assertive');
    // Using simple inline styles to avoid class dependency
    announcer.style.cssText = 'position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); border: 0;';
    announcer.textContent = msg;
    document.body.appendChild(announcer);

    // Remove after the screen reader has had time to grab it
    setTimeout(() => {
      if (announcer.parentNode) document.body.removeChild(announcer);
    }, 8000);
  };

  const handleCartOpening = (cart) => {
    if (window._cartAnnounceInProgress) return;
    window._cartAnnounceInProgress = true;

    // Small buffer to ensure product details have been set by the triggering script
    setTimeout(() => {
      if (document.activeElement && !document.activeElement.closest('[data-ajax-cart-drawer], [data-ajax-cart-trigger], .ajax-cart__overlay')) {
        window._cartOpener = document.activeElement;
      }

      // 1. Unified Announcement
      let announcement = 'Your shopping cart has been opened as a pop-up.';

      console.info('ADA::Cart - Cart opened detected. Pending details:', window._pendingCartDetails);

      const hasPendingDetails = !!window._pendingCartDetails;

      // If we have product details, add them to the same announcement with a slight pause
      if (hasPendingDetails) {
        announcement += ' ' + window._pendingCartDetails + ' added to cart ';
        window._pendingCartDetails = null;
      }

      console.info('ADA::Cart - Final announcement:', announcement);
      announceToSR(announcement);

      // 2. Focus Title (after a delay to ensure the long announcement is heard)
      // 5000ms delay if reading product details, 400ms if just opening the cart
      const focusDelay = hasPendingDetails ? 5000 : 400;

      setTimeout(() => {
        let attempts = 0;
        const maxAttempts = 5;

        const tryFocus = () => {
          attempts++;
          // Use jQuery to find the truly visible title, avoiding hidden mobile/desktop duplicates
          const $title = $('.ajax-cart__cart-item-title').filter(':visible').first();
          const $cartCount = $('.ajax-cart__cart-item-count').filter(':visible').first();

          if ($title.length) {
            $title.attr('tabindex', '0');
            $title.removeAttr('aria-label');
            if ($cartCount.length) $cartCount.attr('tabindex', '0');

            $title.focus();

            // Retry if focus didn't stick (common in complex DOMs)
            if (document.activeElement !== $title[0] && attempts < maxAttempts) {
              setTimeout(tryFocus, 200);
            } else {
              window._cartAnnounceInProgress = false;
            }
          } else if (attempts < maxAttempts) {
            setTimeout(tryFocus, 200);
          } else {
            window._cartAnnounceInProgress = false;
          }
        };

        tryFocus();
      }, focusDelay);
    }, 300);
  };

  const observeCarts = () => {
    const observer = new MutationObserver(() => {
      // The theme uses either the drawer or the mini-cart dropdown
      const cartDrawer = document.querySelector('[data-ajax-cart-drawer]');
      const miniCart = document.querySelector('[data-ajax-cart-trigger]');
      
      let cartContainer = null;
      let isOpen = false;

      if (cartDrawer && cartDrawer.classList.contains('is-visible')) {
        cartContainer = cartDrawer;
        isOpen = true;
      } else if (miniCart && miniCart.classList.contains('show-mini-cart')) {
        cartContainer = miniCart;
        isOpen = true;
      }

      if (isOpen && !window._lastCartState && cartContainer) {
        handleCartOpening(cartContainer);
      }
      window._lastCartState = isOpen;
    });

    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  };

  document.addEventListener('DOMContentLoaded', () => {
    observeCarts();
  });

})();
